<template>
  <div class="wrapper">
    <checar-dispositivo/><br>
    <!-- modal de verificar carregamento total da pagina-->
    <carregando-aguarde/>
    
    <Carregando
      :estaCarregando="processando_login" 
      v-if="processando_login"
      v-cloak/>

    <!-- *********** LOGIN *********** -->
    <div v-if="!processando_login">
      <div v-if="certificandoLogin == 'N'" style="padding: 12% 0 0;"/>
      <div class="form-signin" id="login">
        <img 
          style="width: 15rem;" 
          class="w3-margin-bottom"
          v-if="certificandoLogin == 'N'"
          src="static/imagens/logos/logo_santri.svg">

        <div style="margin-top: 20%;" v-if="certificandoLogin == 'N'"/>

        <input 
          autofocus
          id="usuario"
          type="number"
          class="w3-input"
          data-input="usuario"
          v-model="usuario_id"
          placeholder="Usuário"
          style="margin-bottom:5px;"
          :readonly="certificandoLogin == 'S'"
          v-on:keyup.enter="$event.target.nextElementSibling.focus()"/>

        <input 
          id="senha" 
          ng-hide="true"
          type="password"
          v-model="senha"
          placeholder="Senha"
          data-input="password"
          autocomplete="new-password"
          class="w3-input w3-border-bottom"  
          @keydown.enter="verificarDados()"/>
        <br>

        <div 
          class="w3-container w3-center" 
          v-if="(
            dados_sessao && 
            dados_sessao.tentativas_fracassadas_login && 
            (dados_sessao.tentativas_fracassadas_login > 2)
          )">
          <vue-recaptcha sitekey="6LdDNCQUAAAAAD1-FugFYspeKCsbOAaAwRDvhGTg"/>
        </div>

        <br>

        <button 
          data-button="login" 
          class="w3-btn w3-theme w3-block" 
          id="btLogin" 
          :disabled="processando_login" 
          v-on:click="verificarDados()">
          <i class="fa fa-unlock-alt"/>
          <b> Login</b>
        </button>

        <router-link 
          id="btLogin" 
          to="/sugestoes" 
          data-button="sugestao" 
          class="w3-btn w3-white w3-block w3-border w3-margin-top" 
          v-if="(dados_sessao) && (dados_sessao.utilizar_sugestoes == 'S') && (certificandoLogin == 'N')"
          v-cloak>
          <i class="fa fa-paper-plane w3-text-theme"/>
          <b class="texto-vermelho">Enviar sugestão</b>
        </router-link>

        <router-link
          id="btLoginTerceiros" 
          to="/login-terceiros"
          data-button="terceiros"
          v-if="certificandoLogin == 'N'" 
          class="w3-btn w3-white w3-block w3-border w3-margin-top"
          v-cloak>
          <i class="fa fa-user-friends w3-text-theme"/>
          <b class="texto-vermelho">Sou terceiro</b>
        </router-link>
      </div>

      <p 
        class="texto-cinza w3-white w3-center"
        v-if="(dados_sessao) && (certificandoLogin == 'N')">
        <a href="/Compilacao">ADMWeb {{dados_sessao.versao}} CP {{dados_sessao.compilacao}}</a>
      </p>

      <div 
        style="margin-bottom: 20px;"
        v-if="certificandoLogin == 'S'" 
      />
      
      <modal-coletar-usuario-santri
        v-if="mostrar_modal_usuario_santri"
        @setar_usuario_santri="setarUsuarioSantri"
        @close="fecharModalUsuarioSantri">
      </modal-coletar-usuario-santri>

    </div>

  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha'
  import RSessao from '@/components/Rest/RSessao'
  import Carregando from '@/components/Carregando'
  import RParametro from '@/components/Rest/RParametro'
  import CarregandoAguarde from '@/components/CarregandoAguarde'
  import ChecarDispositivo from '@/components/ChecarDispositivo'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ModalColetarUsuarioSantri from '@/components/ColetarUsuarioSantri'

  export default {
    name: 'Login',
    components: {
      VueRecaptcha,
      ModalColetarUsuarioSantri,
      Carregando,
      CarregandoAguarde,
      ChecarDispositivo,
    },
    props:{
      certificandoLogin: {
        required: false,
        type: String,
        default: "N"
      },

      dadosUsuarioLogado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data () {
      return {
        dados_sessao: undefined,
        processando_login: true,
        
        usuario_id: '',
        senha: '',
        
        recaptcha_response: '',
        nome_usuario_santri: '',
        senha_usuario_santri: '',
        mostrar_modal_usuario_santri: false,
        buscou_dados_compilacao: false,
        quantidade_tentativas_login: 0,
      }
    },
    methods: {
      fecharModalUsuarioSantri() {
        this.mostrar_modal_usuario_santri = false;

        if ((this.nome_usuario_santri == '') || (this.senha_usuario_santri == '')){
          Biblioteca.exclamar('É necessário informar os dados do usuário Santri!');
          return;
        }
        
        this.criarSessao();
      },

      setarUsuarioSantri(obj) {
        this.nome_usuario_santri = obj.nome_usuario_santri;
        this.senha_usuario_santri = obj.senha_usuario_santri;
      },

      async verificarDados(){
        await this.atualizarParametrosLogin();

        if (this.usuario_id.trim() == '') {
          Biblioteca.exclamar('Informe o usuário.');
          return;
        }

        if (this.senha.trim() == '') {
          Biblioteca.exclamar('Informe a senha.');
          return;
        }

        if 
          (
            (this.dados_sessao.treinamento == 'N') &&
            (this.usuario_id == this.dados_sessao.usuario_santri_id)
          )
        {
          this.mostrar_modal_usuario_santri = !this.mostrar_modal_usuario_santri;
          return;
        }

        await this.criarSessao();
      },

      async atualizarParametrosLogin() {
        let parametros_login = await RParametro.buscarParametrosLogin(this.axios, 'N');
        if ((!parametros_login) || (!parametros_login.dados)) {
          return;
        };

        if (parametros_login.houve_erro == 'S'){
          swal(retorno.mensagem);
          return;
        }

        if 
          (
            (this.certificandoLogin == 'N') &&
            (parametros_login.dados.tipo_sessao_criada == 'UAD')
          ) 
        {
          this.$router.replace('/principal');
          return;
        };

        this.dados_sessao = await JSON.parse(JSON.stringify(parametros_login.dados));
        await this.atualizarDadosCompilacao();
      },

      async criarSessao() {
        try {
          if (this.certificandoLogin == 'N'){
            this.processando_login = true;
          }

          let recaptcha_response = '';
          if (this.dados_sessao.tentativas_fracassadas_login > 3) {
            recaptcha_response = grecaptcha.getResponse();
          }

          let compilacao_dist = await buscarCompilacaoDist();

          let parametros = {
            usuario_id: this.usuario_id,
            senha: this.senha,
            nome_usuario_santri: this.nome_usuario_santri,
            senha_usuario_santri: this.senha_usuario_santri,
            'g-recaptcha-response': recaptcha_response,
            compilacao_dist: compilacao_dist,
            sistema_operacional: Biblioteca.buscarSistemaOperacionalDispositivo(),
            navegador: Biblioteca.buscarNomeNavegador(),
            modo_lite_ativo: Biblioteca.buscarModoEconomiaDadosDispositivo() ? 'S' : 'N',
            velocidade: Biblioteca.buscarVelocidadeDownloadDispositivo(true),
            descricao_dispositivo: (
              'Memória ram: ' + Biblioteca.buscarMemoriaRamDispositivo() + ' | ' +
              'Latência: ' + Biblioteca.buscarDadosLatenciaDispositivo() + ' | ' + 
              'Tipo de rede: ' + Biblioteca.buscarTipoRedeDispositivo()
            )
          };

          let retorno = await RSessao.criarSessao(this.axios, parametros, 'N');

          if (retorno.houve_erro != 'N') {
            await this.atualizarParametrosLogin();
            this.quantidade_tentativas_login++;
            this.processando_login = false;
            swal(retorno.mensagem);

            if 
              (
                (this.certificandoLogin == 'S') &&
                (this.quantidade_tentativas_login >= 3)
              )
            {
              this.$router.replace('/');
            }

            return;
          };

          await RSessao.setDadosSessaoUsuario(
            'N',
            retorno.dados.tipo_autenticacao, 
            this.usuario_id
          );

          if (this.certificandoLogin == 'S'){
            this.$emit('confirmarLogin');
            return;
          }

          if (retorno.dados.abrir_carteira_clientes == 'S'){
            this.$router.replace('/carteira-cliente');
          } else {
            this.$router.replace('/principal');
          }
        }
        catch(erro) {
          this.processando_login = false;
          Biblioteca.exclamar(erro.message);
        }
      },

      atualizarDadosCompilacao() {
        if (this.dados_sessao.compilacao_adm) {
          this.dados_sessao.versao = (
            this.dados_sessao.compilacao_adm.substr(0, 1).toString() + '.' +
            this.dados_sessao.compilacao_adm.substr(1, 1).toString() + '.' +
            this.dados_sessao.compilacao_adm.substr(2, 1).toString() + '.' +
            this.dados_sessao.compilacao_adm.substr(3, 1).toString()
          );

          this.dados_sessao.compilacao = (
            this.dados_sessao.compilacao_adm.substr(4, 8).toString()
          );
        }
      },
    },

    created() {
      this.processando_login = true;
    },

    async mounted() {
      await this.atualizarParametrosLogin();

      let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
      recaptchaScript.async = true;
      recaptchaScript.defer = true;
      document.head.appendChild(recaptchaScript);

      this.processando_login = false;

      if (this.certificandoLogin == 'S'){
        this.usuario_id = this.dadosUsuarioLogado.usuario_id;
      }
    }
  }
</script>

<style scoped>
  .form-signin {
    width: 360px;
    margin: auto;
    text-align: center;
    max-width: 95%
  }

  .form-compilacao {
    width: 450px;    
    padding: 8% 0 0;
    margin: auto;
    text-align: center;
    max-width: 95%
  }

  .form {
    position: relative;
    z-index: 1;
    background: #8d1007;
    max-width: 360px;
    margin: 0 auto 100px;
    padding: 45px;
    text-align: center;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
  }

  .form-control{
    margin: 3px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue